/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Schedule replenishment form object.
 * @export
 * @interface ScheduleReplenishmentForm
 */
export interface ScheduleReplenishmentForm {
    /**
     * First day for replenishment order
     * @type {Date}
     * @memberof ScheduleReplenishmentForm
     */
    replenishmentStartDate?: Date;
    /**
     * How frequent replenishment should be activated expressed in days. Mandatory with 'recurrencePeriod=DAILY'.
     * @type {string}
     * @memberof ScheduleReplenishmentForm
     */
    numberOfDays?: string;
    /**
     * How frequent replenishment should be activated expressed in weeks. Mandatory with 'recurrencePeriod=WEEKLY'.
     * @type {string}
     * @memberof ScheduleReplenishmentForm
     */
    numberOfWeeks?: string;
    /**
     * On which date of month replenishment should be activated. Mandatory with 'recurrencePeriod=MONTHLY'.
     * @type {string}
     * @memberof ScheduleReplenishmentForm
     */
    nthDayOfMonth?: string;
    /**
     * Replenishment recurrence period. Available values are DAILY, WEEKLY and MONTHLY. DAILY requires 'numberOfDays'. WEEKLY requires 'daysOfWeek' AND 'numberOfWeeks'. MONTHLY requires 'nthDayOfMonth'.
     * @type {string}
     * @memberof ScheduleReplenishmentForm
     */
    recurrencePeriod?: string;
    /**
     * List of days of week on which replenishment should occur. Mandatory with 'recurrencePeriod=WEEKLY'.
     * @type {Array<string>}
     * @memberof ScheduleReplenishmentForm
     */
    daysOfWeek?: Array<ScheduleReplenishmentFormDaysOfWeekEnum>;
}


/**
 * @export
 */
export const ScheduleReplenishmentFormDaysOfWeekEnum = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY'
} as const;
export type ScheduleReplenishmentFormDaysOfWeekEnum = typeof ScheduleReplenishmentFormDaysOfWeekEnum[keyof typeof ScheduleReplenishmentFormDaysOfWeekEnum];


/**
 * Check if a given object implements the ScheduleReplenishmentForm interface.
 */
export function instanceOfScheduleReplenishmentForm(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScheduleReplenishmentFormFromJSON(json: any): ScheduleReplenishmentForm {
    return ScheduleReplenishmentFormFromJSONTyped(json, false);
}

export function ScheduleReplenishmentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleReplenishmentForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'replenishmentStartDate': !exists(json, 'replenishmentStartDate') ? undefined : (new Date(json['replenishmentStartDate'])),
        'numberOfDays': !exists(json, 'numberOfDays') ? undefined : json['numberOfDays'],
        'numberOfWeeks': !exists(json, 'numberOfWeeks') ? undefined : json['numberOfWeeks'],
        'nthDayOfMonth': !exists(json, 'nthDayOfMonth') ? undefined : json['nthDayOfMonth'],
        'recurrencePeriod': !exists(json, 'recurrencePeriod') ? undefined : json['recurrencePeriod'],
        'daysOfWeek': !exists(json, 'daysOfWeek') ? undefined : json['daysOfWeek'],
    };
}

export function ScheduleReplenishmentFormToJSON(value?: ScheduleReplenishmentForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'replenishmentStartDate': value.replenishmentStartDate === undefined ? undefined : (value.replenishmentStartDate.toISOString()),
        'numberOfDays': value.numberOfDays,
        'numberOfWeeks': value.numberOfWeeks,
        'nthDayOfMonth': value.nthDayOfMonth,
        'recurrencePeriod': value.recurrencePeriod,
        'daysOfWeek': value.daysOfWeek,
    };
}

